import { createContext } from 'react'

export const deviceNumsContext = createContext({})